import React from 'react';
import { createRoot } from 'react-dom/client'
import App from './App';
import dayjs from 'dayjs';
import relativeTime from 'dayjs/plugin/relativeTime';
import localizedFormat from 'dayjs/plugin/localizedFormat';

import * as serviceWorker from './serviceWorker';
import 'antd/dist/reset.css';
import './style.css'

dayjs.extend(localizedFormat);
dayjs.extend(relativeTime);

const rootElement = document.getElementById('root');

if (!rootElement) {
    throw new Error('Failed to find the root element');
}

const root = createRoot(rootElement);
root.render(<App />);

serviceWorker.unregister();
